var map = {
	"./gallery-01.jpg": 12836,
	"./gallery-02.jpg": 6995,
	"./gallery-03.jpg": 20534,
	"./gallery-thumb-01.jpg": 63745,
	"./gallery-thumb-02.jpg": 74166,
	"./gallery-thumb-03.jpg": 37331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42856;